import { Icon } from "@iconify/react/dist/iconify.js"
import AppDialog from "../../../components/Common/AppDialog"
import { Box, Chip, Grid, Stack } from "@mui/material";
import Label from "../../../components/Common/Label";
import Helpers from "../../../helpers/helpers";
import { useNavigate } from "react-router-dom";
import AppAttachmentDialog from "../../../components/Common/AppAttachmentDialog";
import { useState } from "react";

const VehicleDetailsModal = ({ open, close, windowWidth, vehicleDetails, makeList, modelList, bodyList, licenseCategoryList, salesmanList, transmissionList, isDirectSeller }) => {
    const navigate = useNavigate();

    const [attachmentOpen, setAttachmentOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const makeName = makeList?.find((item) => item.id === vehicleDetails?.bike_make_id)?.name || '-';
    const modelName = modelList?.find((item) => item.id === vehicleDetails?.bike_model_id)?.name || '-';
    const licenseCategoryName = licenseCategoryList?.find((item) => item.id === vehicleDetails?.info?.license_category)?.name || '-';

    const renderInfoInGrid = (label, value) => {
        return (
            <Grid item container sm={12}>
                <Grid item lg={3} sm={6} xs={12} className="subheader-2">{label}</Grid>
                <Grid item lg={9} sm={6} xs={12} >{value}</Grid>
            </Grid>
        )
    }
    const testRideSalesman = salesmanList?.find((item) => item.id === vehicleDetails?.info?.test_ride_salesman_id);
    const filterModelList = vehicleDetails?.bike_make_id ? makeList?.find((make) => make.id === vehicleDetails?.bike_make_id)?.models : modelList;
    const filterColorList = filterModelList?.find((item => item?.id === vehicleDetails?.bike_model_id))?.colours || [];

    const renderPricingContent = () => {
        return (
            <>
                {
                    vehicleDetails?.pricing?.pricing_type === 1 && //machine price
                    <div className="d-flex align-items-center my-2">
                        <span className="price-text">${vehicleDetails?.pricing?.machine_price || 0}</span>
                        <span className="subheader-2 mx-2">
                            Instl. ${vehicleDetails?.pricing?.monthly_instalment || 0}/mth
                        </span>
                    </div>
                }
                {
                    vehicleDetails?.pricing?.pricing_type === 2 && //downpayment
                    <>
                        <span className="price-text">${vehicleDetails?.pricing?.min_downpayment || 0}</span>
                        <div className="subheader-2 mb-2">
                            Instl. ${vehicleDetails?.pricing?.monthly_instalment || 0}/mth <span className="mx-2">{'\u2022'}</span>
                            <span className="mx-2">{`Price $${vehicleDetails?.pricing?.machine_price || 0}`}</span>
                        </div>
                    </>
                }
                {
                    vehicleDetails?.pricing?.pricing_type === 3 && //promotion
                    <>
                        <span className="price-text">${vehicleDetails?.pricing?.promotion_price || 0}</span>
                        <div className="subheader-2 mb-2">
                            Instl. ${vehicleDetails?.pricing?.monthly_instalment || 0}/mth <span className="mx-2">{'\u2022'}</span>
                            <span className="mx-2">{`Dp. $${vehicleDetails?.pricing?.min_downpayment || 0}`}</span>
                        </div>
                    </>
                }
                {
                    vehicleDetails?.pricing?.pricing_type === 4 && // selling price
                    <>
                        <span className="price-text">${vehicleDetails?.pricing?.selling_price || 0}</span>
                        <div className="subheader-2 mb-2">
                            Instl. ${vehicleDetails?.pricing?.monthly_instalment || 0}/mth <span className="mx-2">{'\u2022'}</span>
                            <span className="mx-2">{`Dp. $${vehicleDetails?.pricing?.min_downpayment || 0}`}</span>
                        </div>
                    </>
                }
            </>
        )
    }

    const renderRentPriceContent = () => {
        return (
            <>
                <div className="d-flex align-items-end mt-2">
                    <span className="price-text">${vehicleDetails?.rental_rate?.daily_rate || 0}</span>
                    <div className="subheader-2 mx-2" style={{ fontWeight: 400 }}> / day</div>
                </div>
                <Stack flexDirection={'row'} gap={1} mb={1}>
                    <div className="d-flex align-items-center">
                        ${vehicleDetails?.rental_rate?.weekend_rate || 0}
                        <div className="subheader-2 mx-1">weekend,</div>
                    </div>
                    <div className="d-flex align-items-center">
                        ${vehicleDetails?.rental_rate?.['3_days_rate'] || 0}
                        <div className="subheader-2 mx-1">for 3 days,</div>
                    </div>
                    <div className="d-flex align-items-center">
                        ${vehicleDetails?.rental_rate?.weekly_rate || 0}
                        <div className="subheader-2 mx-1">weekly,</div>
                    </div>
                    <div className="d-flex align-items-center">
                        ${vehicleDetails?.rental_rate?.monthly_rate || 0}
                        <div className="subheader-2 mx-1">monthly,</div>
                    </div>
                </Stack>
            </>
        )
    }

    const thumbnailImage = vehicleDetails?.images?.find((item) => item?.type === 'thumbnail');
    const pricingData = vehicleDetails?.pricings?.filter((x, idx) => x?.is_active === 1)?.[0] || ""
    return (
        <>
            <AppDialog
                title={'Vehicle Details'}
                open={open}
                close={close}
                positiveTitle={<div className="d-flex align-items-center"><Icon icon={'ri:pencil-line'} style={{ marginRight: 10 }} />Edit Advert</div>}
                positiveButtonStyle={{ border: '1px solid #1D1B1B', color: '#1D1B1B', backgroundColor: 'white', width: windowWidth <= 768 ? '100%' : 'auto', borderRadius: 20 }}
                positivePress={() => navigate(`/edit-advert/${vehicleDetails?.id}`)}
                negativeTitle={'Close'}
                negativePress={close}
                negativeButtonStyle={{ border: "1px solid #F9F9F9", backgroundColor: '#F9F9F9', color: '#808588', width: windowWidth <= 768 ? '100%' : 'auto', borderRadius: 20 }}
                isMobile={windowWidth <= 768 ? true : false}
            >
                <Grid container >
                    <Grid item lg={2} md={2} sm={12} xs={12} className="subheader-2 p-2">
                        <img
                            alt="vehicle-img"
                            src={thumbnailImage?.base64 || Helpers?.noImage}
                            style={{ width: '100%', height: 120, objectFit: 'contain' }}
                        />
                    </Grid>
                    <Grid item lg={10} md={10} sm={12} xs={12} py={2} px={1}>
                        <Box className="text-bold font-size-18" sx={{ display: { lg: 'flex', md: 'flex', sm: 'block', xs: 'block' }, gap: 1 }}>
                            {vehicleDetails?.info?.title || '-'}
                            <Label.GeneralStatusLabel label={vehicleDetails?.bike_advert_type} list={[{ label: Helpers.capitalize(vehicleDetails?.bike_advert_type || ''), value: vehicleDetails?.bike_advert_type, statusColor: 'light-grey' }]} marginLeft={"0px"} />
                            <Label.GeneralStatusLabel label={vehicleDetails?.status} list={Helpers.advertStatus} marginLeft={"0px"} />
                        </Box>
                        {
                            vehicleDetails?.bike_advert_type === 'rental' ?
                                renderRentPriceContent()
                                :
                                renderPricingContent()
                        }
                        <Box className="align-items-center" sx={{ display: { lg: 'flex', md: 'flex', sm: 'block', xs: 'block' }, gap: 2 }}>
                            <Box >
                                <span className="subheader-2">Advert ID: </span>
                                {vehicleDetails?.display_id || '-'}
                            </Box>
                            <Box>
                                <span className="subheader-2">Listed On: </span>
                                {vehicleDetails?.created_at || '-'}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">Vehicle Details</div>
                        </Grid>
                        {renderInfoInGrid('Make / Model', makeName + ' / ' + modelName)}
                        {renderInfoInGrid('License Category', licenseCategoryName)}
                        {renderInfoInGrid('Primary Colour', filterColorList?.find((color) => color.id === vehicleDetails?.info?.bike_model_colour_id)?.name || '-')}
                        {renderInfoInGrid('Engine Capacity', vehicleDetails?.info?.engine_cc || vehicleDetails?.info?.engine_cap || '-')}
                        {renderInfoInGrid('Transmission', transmissionList?.find((item) => item.id === vehicleDetails?.info?.transmission)?.name || '-')}
                        {renderInfoInGrid('Year of Manufacture', vehicleDetails?.info?.manu_year || '-')}
                    </Grid>
                </div>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">Pricing</div>
                        </Grid>
                        {
                            vehicleDetails?.bike_advert_type === 'rental' ?
                                <>
                                    {renderInfoInGrid('Daily Rate', `$${(vehicleDetails?.rental_rate?.daily_rate)?.toFixed(2) || '-'}`)}
                                    {renderInfoInGrid('Weekend Rate', `$${(vehicleDetails?.rental_rate?.weekly_rate)?.toFixed(2) || '-'}`)}
                                    {renderInfoInGrid('3 Days Rate', `$${(vehicleDetails?.rental_rate?.['3_days_rate'])?.toFixed(2) || '-'}`)}
                                    {renderInfoInGrid('Weekly Rate', `$${(vehicleDetails?.rental_rate?.weekly_rate)?.toFixed(2) || '-'}`)}
                                    {renderInfoInGrid('Monthly Rate', `$${(vehicleDetails?.rental_rate?.monthly_rate)?.toFixed(2) || '-'}`)}
                                </>
                                :
                                <>
                                    {vehicleDetails?.pricing?.pricing_type === 1 ?
                                        renderInfoInGrid('Machine Price', `$${(pricingData?.machine_price)?.toFixed(2) || '-'}`)
                                        : vehicleDetails?.pricing?.pricing_type === 3 ?
                                            renderInfoInGrid('Promotion Price', `$${(pricingData?.promotion_price)?.toFixed(2) || '-'}`)
                                            : vehicleDetails?.pricing?.pricing_type === 4 ?
                                                renderInfoInGrid('Selling Price', `$${(pricingData?.selling_price)?.toFixed(2) || '-'}`)
                                                : ""
                                    }
                                    {
                                        vehicleDetails?.pricing?.pricing_type !== 4 &&
                                        <>
                                            {renderInfoInGrid('Min. Downpayment', `$${(pricingData?.min_downpayment)?.toFixed(2) || '-'}`)}
                                            {renderInfoInGrid('ARF', `$${(pricingData?.arf)?.toFixed(2) || '-'}`)}
                                            {vehicleDetails?.pricing?.pricing_type === 1 &&
                                                renderInfoInGrid('COE', `$${(pricingData?.COE)?.toFixed(2) || '-'}`)}
                                            {vehicleDetails?.pricing?.pricing_type === 2 &&
                                                renderInfoInGrid('Estimated Loan Amount', `$${(pricingData?.estimated_loan_amount)?.toFixed(2) || '-'}`)}
                                            {renderInfoInGrid('Recommended Selling Price', `$${(pricingData?.recommended_selling_price)?.toFixed(2) || '-'}`)}
                                            {vehicleDetails?.pricing?.pricing_type !== 2 &&
                                                renderInfoInGrid('Loan Amount', `$${(pricingData?.loan_amount)?.toFixed(2) || '-'}`)}
                                            {renderInfoInGrid('Max. Loan Tenure', `${(pricingData?.max_loan_tenure?.toFixed(2)) || '-'} month${pricingData?.max_loan_tenure > 1 ? 's' : ''}`)}
                                            {renderInfoInGrid('Interest Rate', `${(pricingData?.interest_rate)?.toFixed(2) || '-'}%`)}
                                            {renderInfoInGrid('Term Charge', `$${(pricingData?.term_charge)?.toFixed(2) || '-'}`)}
                                            {renderInfoInGrid('Monthly Instalment', `$${(pricingData?.monthly_instalment)?.toFixed(2) || '-'}`)}

                                        </>
                                    }
                                </>
                        }
                    </Grid>
                </div>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">Advertisement Details</div>
                        </Grid>
                        {renderInfoInGrid('Listing Title', vehicleDetails?.info?.title)}
                        {renderInfoInGrid('Listing Description', <div dangerouslySetInnerHTML={{ __html: vehicleDetails?.info?.description }}></div>)}
                        {renderInfoInGrid(
                            'Test Ride Url',
                            <>
                                <div>{vehicleDetails?.info?.test_ride_url || '-'}</div>
                                {testRideSalesman && <div>Salesman ({testRideSalesman?.name} {testRideSalesman?.phone} )</div>}
                            </>
                        )}
                    </Grid>
                </div>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">{isDirectSeller ? "Contact" : "Salesman"}</div>
                        </Grid>
                        {isDirectSeller ?
                            <>
                                {renderInfoInGrid('Contact Person', vehicleDetails?.salesmans?.[0]?.name || '-')}
                                {renderInfoInGrid('Contact Number', vehicleDetails?.salesmans?.[0]?.phone || '-')}
                            </>
                            : renderInfoInGrid(
                                'Salesman List',
                                <ol className="p-0 px-2">
                                    {
                                        vehicleDetails?.salesmans?.length > 0 ?
                                            vehicleDetails.salesmans.map((salesman) => (
                                                <li key={salesman.id}>{salesman.name || salesman?.salesman_name || "-"} / {salesman.phone || salesman?.salesman_phone || "-"} / {salesman.location_name || '-'}</li>
                                            ))
                                            : null
                                    }
                                </ol>
                            )}
                    </Grid>
                </div>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">Media</div>
                        </Grid>
                        <Grid item container sm={12}>
                            <Grid item lg={3} sm={6} xs={12} className="subheader-2">Photos</Grid>
                            <Grid item container spacing={2} lg={9} sm={6} xs={12} >
                                {
                                    vehicleDetails?.images && vehicleDetails?.images?.find((item) => item?.type === 'thumbnail') &&
                                    vehicleDetails.images?.filter((item) => item?.type === 'thumbnail').map((item, index) => (
                                        <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
                                            <div style={{ position: 'relative', width: 'inherit', }}>
                                                <img
                                                    className="clickable"
                                                    src={item?.base64 || Helpers.noImage}
                                                    style={{ height: 120, width: '100%', objectFit: 'contain' }}
                                                    onClick={() => { setSelectedFile(item); setAttachmentOpen(true) }}
                                                />
                                                <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
                                                    <Chip label={"Thumbnail"} style={{ color: "white", border: "1px solid white", backgroundColor: "#D13536", height: "20px", marginLeft: 2, marginBottom: 2 }} />
                                                </div>
                                            </div>
                                        </Grid>
                                    ))
                                }
                                {
                                    vehicleDetails?.images && vehicleDetails.images?.filter((item) => item?.type !== 'thumbnail').length > 0 &&
                                    vehicleDetails.images?.filter((item) => item?.type !== 'thumbnail').map((item, index) => (
                                        <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
                                            <img
                                                className="clickable"
                                                src={item?.base64 || Helpers.noImage}
                                                style={{ width: '100%', height: 120, objectFit: 'contain' }}
                                                onClick={() => { setSelectedFile(item); setAttachmentOpen(true) }}
                                            />
                                        </Grid>
                                    ))
                                }
                                {!vehicleDetails?.images || vehicleDetails.images.length === 0 ? <Grid item sm={12}>-</Grid> : null}
                            </Grid>
                        </Grid>
                        {renderInfoInGrid(
                            'Video URLs',
                            <ol className="text-bold p-0 px-2">
                                <li>Youtube: <span>{vehicleDetails?.info?.youtube_url || '-'}</span></li>
                                <li>Facebook: <span>{vehicleDetails?.info?.facebook_url || '-'}</span></li>
                                <li>Instagram: <span>{vehicleDetails?.info?.instagram_url || '-'}</span></li>
                                <li>TikTok: <span>{vehicleDetails?.info?.tiktok_url || '-'}</span></li>
                            </ol>
                        )}
                    </Grid>
                </div>
            </AppDialog>
            <AppAttachmentDialog
                open={attachmentOpen}
                close={() => setAttachmentOpen(false)}
                file={selectedFile?.base64}
                fileName={selectedFile?.attachment_name}
                filetype={selectedFile?.file_format}
            />
        </>
    )
}

export default VehicleDetailsModal;
